import { render, staticRenderFns } from "./PromptLocaleEditor.vue?vue&type=template&id=e75cf9bc&scoped=true"
import script from "./PromptLocaleEditor.vue?vue&type=script&lang=ts"
export * from "./PromptLocaleEditor.vue?vue&type=script&lang=ts"
import style0 from "./PromptLocaleEditor.vue?vue&type=style&index=0&id=e75cf9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75cf9bc",
  null
  
)

export default component.exports